// CSS is pre-compiled by Tailwind CLI and injected into Shadow DOM via __COMPILED_CSS__ define constant
// (see tsup.config.ts — no runtime CSS import needed for IIFE build)

// Initialize environment configuration first
import { setupViteEnv } from '@skin-seoul/env-utils/vite';
import { ConfigReader } from './config/configReader';

// Get build-time injected environment config
declare const ENV_CONFIG: Record<string, string>;

// Inject environment variables into globalThis for universal compatibility
const envConfig = typeof ENV_CONFIG !== 'undefined' ? ENV_CONFIG : undefined;
setupViteEnv(envConfig);

// Override server origin using runtime hostname logic
const runtimeServerOrigin = ConfigReader.getApiDomain();
const runtimeFrontendOrigin = ConfigReader.getFrontendOrigin();
const runtimeMediaOrigin = ConfigReader.getMediaOrigin();
const runtimeEventOrigin = ConfigReader.getEventOrigin();
const runtimeAnalyticsHmacSecret = ConfigReader.getAnalyticsHmacSecret();
if (typeof globalThis !== 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (globalThis as any).__ENV = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...(globalThis as any).__ENV,
    NEXT_PUBLIC_ENV_SERVER_ORIGIN: runtimeServerOrigin,
    NEXT_PUBLIC_ENV_FRONTEND_ORIGIN: runtimeFrontendOrigin,
    NEXT_PUBLIC_ENV_MEDIA_ORIGIN: runtimeMediaOrigin,
    NEXT_PUBLIC_ENV_EVENT_ORIGIN: runtimeEventOrigin,
    NEXT_PUBLIC_ANALYTICS_HMAC_SECRET: runtimeAnalyticsHmacSecret,
  };
  console.info('[reactshortcode] Runtime NEXT_PUBLIC_ENV_SERVER_ORIGIN set to', runtimeServerOrigin);
}

// Dynamically import mount logic AFTER environment variables are set
async function bootstrap() {
  const { mountComponents, unmountAllComponents } = await import('./core/mount');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountComponents);
  } else {
    mountComponents();
  }

  const unmountButton = document.getElementById('unmountButton');
  if (unmountButton) {
    unmountButton.addEventListener('click', unmountAllComponents);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).SkinSeoulReactShortcode = {
    initialize: mountComponents,
    unmountAll: unmountAllComponents,
  };
}

bootstrap();
